export enum Appointment {
  NA = 'N/A',
  THREE_MONTHS = '3 months',
  SIX_MONTHS = '6 months',
  TWELVE_MONTHS = '12 months',
  TWENTY_FOUR_MONTHS = '24 months',
  THIRTY_SIX_MONTHS = '36 months',
  REFERRAL = 'Referral',
}
